import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Cluster } from './cluster.interface';
import { ClusterService } from './cluster.service';

const service = new ClusterService();

export interface ClusterState {
   clustersOverview?: ApiResource<Array<Cluster>>;
}

const ClusterStore: Module<ClusterState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_CLUSTERS_OVERVIEW(state, clustersOverview?: ApiResource<Array<Cluster>>) {
         state.clustersOverview = clustersOverview;
      },
      ADD_CLUSTER(state, cluster: Cluster) {
         state.clustersOverview?.data.push(cluster);
      },
      SET_CLUSTER(state, cluster: Cluster) {
         const index = (state.clustersOverview?.data || []).findIndex((c) => c.id === cluster.id);
         if (index > -1) state.clustersOverview?.data.splice(index, 1, cluster);
      },
      REMOVE_CLUSTER(state, clusterId: number) {
         const index = (state.clustersOverview?.data || []).findIndex((c) => c.id === clusterId);
         if (index > -1) state.clustersOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getClusters(context, query?: LocationQuery) {
         const clusters = await service.getClusters(query);
         context.commit('SET_CLUSTERS_OVERVIEW', clusters);
         return clusters;
      },
      async createCluster(context, cluster: Cluster) {
         const response = await service.postCluster(cluster);
         context.commit('ADD_CLUSTER', response.data);
         return response.data;
      },
      async changeCluster(context, payload: { clusterId: number; cluster: Cluster }) {
         const response = await service.putCluster(payload.clusterId, payload.cluster);
         context.commit('SET_CLUSTER', response.data);
         return response.data;
      },
      async deleteCluster(context, clusterId: number) {
         const response = await service.deleteCluster(clusterId);
         context.commit('REMOVE_CLUSTER', clusterId);
         return response;
      },
   },
};

export default ClusterStore;
